import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  screen: "/",
  galleryOrDashboard: "dashboard",
  location: "",
  disableScreens: false,
  token: "",
  loc: "",
  storeCode: "",
  searchTextDropdown: "",
  openSideBar: false,
  tokenErr: false,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    screenChange: (state, action) => {
      state.screen = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setDisableScreen: (state, action) => {
      state.disableScreens = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setLoc: (state, action) => {
      state.loc = action.payload;
    },
    setStoreCodeRedirect: (state, action) => {
      state.storeCode = action.payload;
    },
    setSearchTextDropdown: (state, action) => {
      state.searchTextDropdown = action.payload;
    },
    setGalleryOrDashboard: (state, action) => {
      state.galleryOrDashboard = action.payload;
    },
    openSideBarModal(state, action) {
      state.openSideBar = action.payload;
    },
    setTokenErr(state, action) {
      state.tokenErr = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  screenChange,
  setLocation,
  setDisableScreen,
  setToken,
  setLoc,
  setStoreCodeRedirect,
  setSearchTextDropdown,
  setGalleryOrDashboard,
  openSideBarModal,
  setTokenErr,
} = commonSlice.actions;

export default commonSlice.reducer;
